import FormDialog from "src/components/common/FormDialog";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment";
import { useEffect, useState } from "react";
import { asyncRequest } from "src/services/network";
import MyPagination from "src/components/common/MyPagination";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Grid } from "@mui/material";
import dayjs from "dayjs";

const AccountTransactionsDialog = ({ accountId, open, onClose }) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
    date: dayjs(),
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/finance/huifu/account/logs",
      data: {
        ...filter,
        accountId
      },
    });

    setItems(data);
    setTotal(count);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  return (
    <FormDialog title="流水记录" open={open} onClose={onClose} onConfirm={onClose}>
      <TableContainer component={Paper}>
      <Grid container rowGap={2}>
          <Grid item lg={6} sm={6} md={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker defaultValue={filter.date} label="选择日期" onChange={e => {
                setFilter({
                  ...filter,
                  date: e
                })
              }} />
            </LocalizationProvider>
          </Grid>
        </Grid>
        <Table sx={{ minWidth: 500 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>序号</TableCell>
              <TableCell>流水号</TableCell>
              <TableCell>类型</TableCell>
              <TableCell align="right">财务时间</TableCell>
              <TableCell align="right">金额</TableCell>
              <TableCell align="right">手续费</TableCell>
              <TableCell align="right">余额</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((row, index) => (
              <TableRow key={row.name} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                <TableCell component="th" scope="row">{index + 1}</TableCell>
                <TableCell align="right">{row.acct_log_id}</TableCell>
                <TableCell align="right">{row.acct_trans_type}</TableCell>
                <TableCell align="right">{row.trans_date_time}</TableCell>
                <TableCell align="right">{row.trans_amt}</TableCell>
                <TableCell align="right">{row.fee_amt}</TableCell>
                <TableCell align="right">{row.balance_amt}</TableCell>
                <TableCell align="right">{row.total}</TableCell>
                {/* <TableCell align="right">{moment(row.createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell> */}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
    </FormDialog>
  );
};

export default AccountTransactionsDialog;
